const noop = () => {}; //eslint-disable-line no-empty-function
export default noop;
